<!-- eslint-disable max-len -->
<template>
  <div>
    <LoadingSpinner v-if="loading" />

    <div
      v-if="!loading && !isEmpty(details)"
      class="block relative w-full mt-2 pb-4"
    >
      <div class="body_inners pl-4 pr-4">
        <div class="title-block block relative mb-4">
          <h2
            class="
              title-block
              block
              text-lgg
              font-bold
              m-0
              text-darkblack text-center
              capitalize
            "
          >
            {{ $t("pages.questionnaire.title") }}
          </h2>
        </div>
        <div
          class="
            block
            relative
            walter-block
            bg-white
            rounded-lg
            walter-shadow
            mb-4
          "
        >
          <div class="flex align-start justify-start top-block mb-0 p-4">
            <div class="left-block w-2/4 relative">
              <h4
                class="
                  block
                  relative
                  text-sm
                  font-bold
                  text-darkblack
                  flex
                  items-center
                  justify-start
                "
              >
                {{ $t("pages.common.buttons.dis73") }}:
                {{ details.customer.id }}
                <span class="flex ml-1.5">
                  <div class="wrapper flex">
                    <svg
                      class="w-3.5 h-3.5 show"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      v-if="details.customer.all_missions > 0"
                      @click="showModal = !showModal"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M5.2689 1.16248C5.38881 1.14971 5.51671 1.18009 5.63283 1.26143L6.21616 1.67029C6.73932 2.0362 7.44074 2.03665 7.96356 1.67029L8.54624 1.26143C8.8559 1.04451 9.25191 1.18848 9.34963 1.55375L9.53322 2.2419C9.69814 2.8585 10.2352 3.30883 10.8711 3.3643L11.5801 3.42615C11.9567 3.45901 12.1676 3.82404 12.0078 4.16638L11.7064 4.81156C11.4365 5.38997 11.5581 6.08039 12.0098 6.53162L12.513 7.03487C12.7803 7.30194 12.7072 7.71698 12.3646 7.87667L11.7194 8.17745C11.1406 8.44679 10.7907 9.0535 10.8464 9.68917L10.9089 10.3988C10.9419 10.7754 10.6187 11.0463 10.2539 10.9483L9.56642 10.7634C8.9499 10.598 8.29107 10.8375 7.92515 11.3604L7.51694 11.9437C7.30021 12.2535 6.87886 12.2542 6.66213 11.9444L6.25392 11.3604C5.888 10.8375 5.22982 10.598 4.6133 10.7634L3.92515 10.9483C3.56032 11.0463 3.23781 10.7754 3.27085 10.3988L3.33335 9.68982C3.38931 9.05391 3.03863 8.44623 2.45965 8.1768L1.81447 7.87667C1.4717 7.71692 1.3985 7.3024 1.66603 7.03487L2.16994 6.53162C2.62166 6.08039 2.74321 5.38997 2.47332 4.81156L2.17189 4.16638C2.01209 3.82404 2.22239 3.45901 2.59898 3.42615L3.30861 3.3643C3.94453 3.30883 4.48093 2.8585 4.64585 2.2419L4.8301 1.55375C4.87895 1.37112 5.0025 1.24371 5.15236 1.18917C5.18983 1.17553 5.22892 1.16673 5.2689 1.16248ZM9.1465 4.6462C9.23711 4.55311 9.3604 4.49894 9.49025 4.49516C9.5909 4.49226 9.69008 4.51981 9.77481 4.57421C9.85954 4.62861 9.92587 4.70732 9.96513 4.80005C10.0044 4.89277 10.0147 4.99518 9.99482 5.09389C9.97491 5.19259 9.92567 5.28298 9.85353 5.35323L6.5202 8.68656C6.42643 8.7803 6.29927 8.83295 6.16668 8.83295C6.0341 8.83295 5.90694 8.7803 5.81317 8.68656L4.1465 7.0199C4.09852 6.97382 4.06021 6.91864 4.03381 6.85758C4.00742 6.79651 3.99348 6.7308 3.9928 6.66428C3.99213 6.59776 4.00473 6.53177 4.02988 6.47018C4.05502 6.4086 4.0922 6.35264 4.13924 6.3056C4.18628 6.25856 4.24223 6.22139 4.30382 6.19624C4.36541 6.1711 4.43139 6.15849 4.49791 6.15917C4.56443 6.15984 4.63015 6.17379 4.69121 6.20018C4.75228 6.22657 4.80746 6.26488 4.85353 6.31287L6.16668 7.62602L9.1465 4.6462Z"
                        fill="#4890D2"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.97267 0.442424C8.23903 0.255836 8.54113 0.170709 8.83921 0.172892C9.49498 0.177696 10.1302 0.60408 10.3151 1.29529L10.4994 1.98344C10.5564 2.19684 10.7376 2.34901 10.9577 2.3682L11.6673 2.43005C12.7041 2.52052 13.3536 3.64656 12.9134 4.58956L12.6126 5.23474C12.5192 5.435 12.5599 5.66783 12.7162 5.82393L13.2201 6.32719C13.9562 7.06279 13.7305 8.34327 12.7871 8.78292L12.1419 9.0837C11.9416 9.17694 11.8231 9.38184 11.8425 9.60193L11.905 10.3116C11.9959 11.3483 11 12.1838 9.99481 11.9138L9.30731 11.7295C9.09383 11.6723 8.87155 11.7528 8.74481 11.934L8.33661 12.5173C7.74001 13.3701 6.43972 13.3701 5.84312 12.5173L5.43491 11.934C5.30817 11.7528 5.08589 11.6723 4.87241 11.7295L4.18491 11.9138C3.17974 12.1838 2.1838 11.3483 2.27476 10.3116L2.33726 9.60193C2.35663 9.38184 2.23813 9.17694 2.03778 9.0837L1.39194 8.78292C0.448711 8.34333 0.223198 7.06299 0.959001 6.32719L1.46291 5.82393C1.61919 5.66783 1.66052 5.435 1.56707 5.23474L1.26564 4.58891C0.825447 3.64591 1.47564 2.52052 2.51239 2.43005L3.22137 2.3682C3.44145 2.34901 3.62263 2.19684 3.6797 1.98344L3.86395 1.29529C4.06566 0.541243 4.80313 0.102953 5.5189 0.182658C5.75748 0.209227 5.99396 0.293154 6.20705 0.442424L6.78973 0.851278C6.97191 0.9787 7.20815 0.978245 7.38934 0.851278L7.97267 0.442424ZM5.63283 1.26143C5.51671 1.18009 5.38881 1.14971 5.2689 1.16248C5.22892 1.16673 5.18983 1.17553 5.15236 1.18917C5.0025 1.24371 4.87895 1.37112 4.8301 1.55375L4.64585 2.2419C4.48093 2.8585 3.94453 3.30883 3.30861 3.3643L2.59898 3.42615C2.22239 3.45901 2.01209 3.82404 2.17189 4.16638L2.47332 4.81156C2.74321 5.38997 2.62166 6.08039 2.16994 6.53162L1.66603 7.03487C1.3985 7.3024 1.4717 7.71692 1.81447 7.87667L2.45965 8.1768C3.03863 8.44623 3.38931 9.05391 3.33335 9.68982L3.27085 10.3988C3.23781 10.7754 3.56032 11.0463 3.92515 10.9483L4.6133 10.7634C5.22982 10.598 5.888 10.8375 6.25392 11.3604L6.66213 11.9444C6.87886 12.2542 7.30021 12.2535 7.51694 11.9437L7.92515 11.3604C8.29107 10.8375 8.9499 10.598 9.56642 10.7634L10.2539 10.9483C10.6187 11.0463 10.9419 10.7754 10.9089 10.3988L10.8464 9.68917C10.7907 9.0535 11.1406 8.44679 11.7194 8.17745L12.3646 7.87667C12.7072 7.71698 12.7803 7.30194 12.513 7.03487L12.0098 6.53162C11.5581 6.08039 11.4365 5.38997 11.7064 4.81156L12.0078 4.16638C12.1676 3.82404 11.9567 3.45901 11.5801 3.42615L10.8711 3.3643C10.2352 3.30883 9.69814 2.8585 9.53322 2.2419L9.34963 1.55375C9.25191 1.18848 8.8559 1.04451 8.54624 1.26143L7.96356 1.67029C7.44074 2.03665 6.73932 2.0362 6.21616 1.67029L5.63283 1.26143Z"
                        fill="#4890D2"
                      />
                    </svg>
                    <span v-if="showModal" class="tooltip">{{
                      $t("pages.common.buttons.dis125")
                    }}</span>
                  </div>
                </span>
              </h4>

              
              <p
                class="
                  flex
                  items-center
                  justify-start
                  mt-0.5
                  mb-0
                  text-xs
                  font-medium
                  text-darkgray1
                "
              >
                <span class="mr-1.5">
                  <svg
                    class="w-3.5 h-3.5"
                    viewBox="0 0 10 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.99984 0.666992C2.2667 0.666992 0.0415039 2.89219 0.0415039 5.62533C0.0415039 6.85231 0.491635 7.97757 1.23096 8.84277L1.23324 8.84505L1.23494 8.84733C1.23494 8.84733 3.34426 11.2542 4.09522 11.9708C4.59809 12.4502 5.40102 12.4502 5.90389 11.9708C6.75987 11.1544 8.7653 8.84619 8.7653 8.84619L8.76644 8.84448L8.76815 8.84277C9.50813 7.97756 9.95817 6.85231 9.95817 5.62533C9.95817 2.89219 7.73297 0.666992 4.99984 0.666992ZM4.99984 1.54199C7.26004 1.54199 9.08317 3.36513 9.08317 5.62533C9.08317 6.63893 8.71379 7.55983 8.10278 8.27425C8.09881 8.2788 6.04693 10.6255 5.30005 11.3379C5.12684 11.503 4.87227 11.503 4.69906 11.3379C4.07484 10.7423 1.90266 8.28143 1.89632 8.27425L1.89575 8.27368C1.28556 7.55932 0.916504 6.63865 0.916504 5.62533C0.916504 3.36513 2.73964 1.54199 4.99984 1.54199ZM4.99984 3.87533C4.45296 3.87533 3.98741 4.09616 3.68848 4.43245C3.38955 4.76875 3.24984 5.19998 3.24984 5.62533C3.24984 6.05067 3.38955 6.4819 3.68848 6.8182C3.98741 7.15449 4.45296 7.37533 4.99984 7.37533C5.54671 7.37533 6.01227 7.15449 6.3112 6.8182C6.61013 6.4819 6.74984 6.05067 6.74984 5.62533C6.74984 5.19998 6.61013 4.76875 6.3112 4.43245C6.01227 4.09616 5.54671 3.87533 4.99984 3.87533ZM4.99984 4.75033C5.32796 4.75033 5.51866 4.85762 5.65723 5.01351C5.7958 5.1694 5.87484 5.39442 5.87484 5.62533C5.87484 5.85623 5.7958 6.08125 5.65723 6.23714C5.51866 6.39303 5.32796 6.50033 4.99984 6.50033C4.67171 6.50033 4.48102 6.39303 4.34245 6.23714C4.20388 6.08125 4.12484 5.85623 4.12484 5.62533C4.12484 5.39442 4.20388 5.1694 4.34245 5.01351C4.48102 4.85762 4.67171 4.75033 4.99984 4.75033Z"
                      fill="#676666"
                    />
                  </svg>
                </span>
                {{ details.location }}
              </p>
            </div>

            <div class="right-block w-2/4 relative">
              <p
                class="
                  wishlist-icon
                  relative
                  text-sm text-right
                  flex
                  items-center
                  justify-end
                  mt-0
                  font-bold
                "
                @click="
                  $store.dispatch('offer/toggleFav', {
                    offerId: $route.params.id,
                    page: 'details',
                  })
                "
              >
                <button
                  v-if="details.favorite"
                  @click.prevent="selectedOffers(details.offer_id, details)"
                  :details="details"
                >
                  <svg
                    v-if="details.favorite"
                    width="20"
                    height="18"
                    viewBox="0 0 20 18"
                    fill="none"
                    :active="true"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.5 0.5C2.47122 0.5 0 2.97122 0 6C0 8.04808 1.54382 9.97645 3.42578 11.9541C5.30774 13.9318 7.62419 15.9347 9.46973 17.7803C9.61038 17.9209 9.80112 17.9999 10 17.9999C10.1989 17.9999 10.3896 17.9209 10.5303 17.7803C12.3758 15.9347 14.6923 13.9318 16.5742 11.9541C18.4562 9.97645 20 8.04808 20 6C20 2.97122 17.5288 0.5 14.5 0.5C12.7618 0.5 11.2484 1.43324 10 3.01855C8.75159 1.43324 7.23822 0.5 5.5 0.5ZM5.5 2C6.96429 2 8.18315 2.7792 9.36621 4.65039C9.43386 4.75727 9.52744 4.84531 9.63826 4.90632C9.74907 4.96732 9.87351 4.99931 10 4.99931C10.1265 4.99931 10.2509 4.96732 10.3617 4.90632C10.4726 4.84531 10.5661 4.75727 10.6338 4.65039C11.8168 2.7792 13.0357 2 14.5 2C16.7182 2 18.5 3.78178 18.5 6C18.5 7.20192 17.2938 9.02355 15.4883 10.9209C13.8418 12.6511 11.7952 14.4587 10 16.209C8.20484 14.4587 6.15821 12.6511 4.51172 10.9209C2.70618 9.02355 1.5 7.20192 1.5 6C1.5 3.78178 3.28178 2 5.5 2Z"
                      fill="#63B15B"
                    />
                    <path
                      d="M5.5 2C6.96429 2 8.18315 2.7792 9.36621 4.65039C9.43386 4.75727 9.52744 4.84531 9.63826 4.90632C9.74907 4.96732 9.87351 4.99931 10 4.99931C10.1265 4.99931 10.2509 4.96732 10.3617 4.90632C10.4726 4.84531 10.5661 4.75727 10.6338 4.65039C11.8168 2.7792 13.0357 2 14.5 2C16.7182 2 18.5 3.78178 18.5 6C18.5 7.20192 17.2938 9.02355 15.4883 10.9209C13.8418 12.6511 11.7952 14.4587 10 16.209C8.20484 14.4587 6.15821 12.6511 4.51172 10.9209C2.70618 9.02355 1.5 7.20192 1.5 6C1.5 3.78178 3.28178 2 5.5 2Z"
                      fill="#63B15B"
                    />
                  </svg>
                </button>
                <button
                  v-else
                  @click.prevent="selectedOffers(details.offer_id, details)"
                  :class="details.favorite === true ? true : false"
                  :details="details"
                >
                  <svg
                    width="20"
                    height="18"
                    viewBox="0 0 20 18"
                    :active="false"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.5 0.5C2.47122 0.5 0 2.97122 0 6C0 8.04808 1.54382 9.97645 3.42578 11.9541C5.30774 13.9318 7.62419 15.9347 9.46973 17.7803C9.61038 17.9209 9.80112 17.9999 10 17.9999C10.1989 17.9999 10.3896 17.9209 10.5303 17.7803C12.3758 15.9347 14.6923 13.9318 16.5742 11.9541C18.4562 9.97645 20 8.04808 20 6C20 2.97122 17.5288 0.5 14.5 0.5C12.7618 0.5 11.2484 1.43324 10 3.01855C8.75159 1.43324 7.23822 0.5 5.5 0.5ZM5.5 2C6.96429 2 8.18315 2.7792 9.36621 4.65039C9.43386 4.75727 9.52744 4.84531 9.63826 4.90632C9.74907 4.96732 9.87351 4.99931 10 4.99931C10.1265 4.99931 10.2509 4.96732 10.3617 4.90632C10.4726 4.84531 10.5661 4.75727 10.6338 4.65039C11.8168 2.7792 13.0357 2 14.5 2C16.7182 2 18.5 3.78178 18.5 6C18.5 7.20192 17.2938 9.02355 15.4883 10.9209C13.8418 12.6511 11.7952 14.4587 10 16.209C8.20484 14.4587 6.15821 12.6511 4.51172 10.9209C2.70618 9.02355 1.5 7.20192 1.5 6C1.5 3.78178 3.28178 2 5.5 2Z"
                      fill="#63B15B"
                    />
                  </svg>
                </button>
              </p>
            </div>
          </div>

          <div
            class="
              flex
              align-start
              justify-start
              top-block
              mb-0
              pl-4
              pt-0
              pr-4
              pb-4
            "
          >
            <div class="left-block w-2/4 relative">
              <h4
                class="
                  block
                  relative
                  text-sm
                  font-bold
                  text-darkblack
                  flex
                  items-center
                  justify-start
                "
              >
                {{
                  formatDate(details.arrival_date, "DD.MM.YYYY", "YYYY-MM-DD")
                }}
              </h4>
            </div>

            <div class="right-block w-2/4 relative">
              <p
                class="
                  wishlist-icon
                  relative
                  text-smm text-right
                  flex
                  items-center
                  justify-end
                  mt-0
                  font-bold
                "
              >
                <span class="mr-0.5">
                  <svg
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.99992 0.833008C3.32394 0.833008 0.333252 3.8237 0.333252 7.49967C0.333252 11.1757 3.32394 14.1663 6.99992 14.1663C10.6759 14.1663 13.6666 11.1757 13.6666 7.49967C13.6666 3.8237 10.6759 0.833008 6.99992 0.833008ZM7.1731 3.83301C8.49643 3.83301 9.06283 4.39182 9.5175 4.84082C9.71416 5.03482 9.71605 5.35118 9.52205 5.54785C9.32839 5.74452 9.01102 5.74641 8.81502 5.55241C8.40802 5.15074 8.08675 4.83301 7.17375 4.83301C6.37141 4.83301 5.67052 5.37067 5.29419 6.16634H6.83325C7.10925 6.16634 7.33325 6.39001 7.33325 6.66634C7.33325 6.94267 7.10925 7.16634 6.83325 7.16634H5.0188C5.00747 7.27567 4.99992 7.38667 4.99992 7.49967C4.99992 7.61267 5.00747 7.72367 5.0188 7.83301H6.83325C7.10925 7.83301 7.33325 8.05667 7.33325 8.33301C7.33325 8.60934 7.10925 8.83301 6.83325 8.83301H5.29419C5.67086 9.62867 6.37076 10.1663 7.1731 10.1663C8.0861 10.1663 8.40769 9.84861 8.81502 9.44694C9.01102 9.25294 9.32839 9.25516 9.52205 9.4515C9.71605 9.64816 9.71416 9.96486 9.5175 10.1585C9.06283 10.6079 8.49675 11.1663 7.17375 11.1663C5.83108 11.1663 4.68329 10.1967 4.22062 8.83301H3.49992C3.22392 8.83301 2.99992 8.60934 2.99992 8.33301C2.99992 8.05667 3.22392 7.83301 3.49992 7.83301H4.01489C4.00623 7.72301 3.99992 7.61234 3.99992 7.49967C3.99992 7.38701 4.00623 7.27634 4.01489 7.16634H3.49992C3.22392 7.16634 2.99992 6.94267 2.99992 6.66634C2.99992 6.39001 3.22392 6.16634 3.49992 6.16634H4.21997C4.68297 4.80267 5.83076 3.83301 7.1731 3.83301Z"
                      fill="#63B15B"
                    />
                  </svg>
                </span>
                {{ formatPrice(details.compensation) }} Euro
              </p>
            </div>
          </div>
        </div>
        <div v-if="details.patients.length == 2">
          <label
            v-if="details.questionnaire_type === 'new'"
            class="block relative text-sm font-bold text-darkgray mb-4 mt-4"
          >
            {{ $t("pages.questionnaire.select_option.label") }}
          </label>
        </div>

        <div v-if="details.patients.length == 2">
          <div
            v-if="details.questionnaire_type === 'new'"
            class="
              flex
              align-start
              justify-start
              w-full
              border
              solid
              border-color
              h-10
              rounded
              mb-4
            "
          >
            <div class="w-2/4 h-full border-r solid border-color">
              <label
                class="
                  w-full
                  h-full
                  flex
                  items-center
                  justify-center
                  text-center text-sm
                  font-medium
                  capitalize
                "
                :class="
                  patientIdx === 1
                    ? 'bg-darkgreen text-white'
                    : 'text-darkgray1'
                "
                @click="patientIdx = 1"
              >
                {{ $t("pages.questionnaire.select_option.first") }}
              </label>
            </div>

            <div class="w-2/4 h-full">
              <label
                class="
                  w-full
                  h-full
                  flex
                  items-center
                  justify-center
                  text-center text-sm
                  font-medium
                  capitalize
                "
                :class="[
                  patientIdx === 2
                    ? 'bg-darkgreen text-white'
                    : 'text-darkgray1',
                  details.patients.length === 2 ? ' cursor-not-allowed' : '',
                ]"
                @click="
                  () => {
                    if (details.patients.length === 2) {
                      patientIdx = 2;
                    }
                  }
                "
              >
                {{ $t("pages.questionnaire.select_option.second") }}
              </label>
            </div>
          </div>
        </div>

        <div class="relative block accordian-list-block">
          <IndicationOfCareSituation
            :patient="details.patients[patientIdx - 1]"
          />

          <HealthConditionDetails
            v-if="details.questionnaire_type === 'new'"
            :patient="details.patients[patientIdx - 1]"
          />

          <ScopeOfServices
            v-if="details.questionnaire_type === 'new'"
            :details="details"
            :patient-idx="patientIdx"
          />
          <ScopeOfServices
            v-if="details.questionnaire_type === 'old'"
            :details="details"
            :patient-idx="patientIdx"
          />

          <Household v-if="details.questionnaire_type === 'old'" />

          <Support
            v-if="details.questionnaire_type === 'new'"
            :details="details"
          />

          <HouseholdSituations :details="details" />

          <InfoAboutCustomer :details="details" />

          <div class="form-group mb-2 w-full">
            <button
              class="
                w-full
                flex
                items-center
                justify-center
                btn_apply
                rounded-lg
                text-white
                btn_action
              "
              @click="showApplyForm = true"
            >
              {{ $t("pages.questionnaire.button_1") }}
            </button>
          </div>
          <label
            class="
              block
              relative
              text-center text-darkgreen text-sm
              font-medium
              mb-2
            "
          >
            {{ $t("pages.questionnaire.or") }}
          </label>
          <div class="block relative form-group mb-2">
            <button
              class="
                relative
                flex
                items-center
                justify-center
                flex-nowrap
                text-darkblack text-sm
                walter-footer
                pt-3
                pb-3
                pl-4
                pr-4
                border
                solid
                border-darkgreen
                rounded
                btn-transparent
                w-full
                text-center
              "
              @click="
                () => {
                  this.$router.push({ name: 'RequestInformation' });
                }
              "
            >
              <span class="text-sm mr-1 font-semibold text-darkgreen">
                {{ $t("pages.questionnaire.button_2") }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <ApplyApplication
      v-if="showApplyForm"
      :details="details"
      @hideMe="showApplyForm = false"
    />
  </div>
</template>

<script>
import IndicationOfCareSituation from "@/pages/offer-details-questionnaire/parts/IndicationOfCareSituation";
import HealthConditionDetails from "@/pages/offer-details-questionnaire/parts/HealthConditionDetails";
import ScopeOfServices from "@/pages/offer-details-questionnaire/parts/ScopeOfServices";
import Support from "@/pages/offer-details-questionnaire/parts/Support";
import HouseholdSituations from "@/pages/offer-details-questionnaire/parts/HouseholdSituations";
import InfoAboutCustomer from "@/pages/offer-details-questionnaire/parts/InfoAboutCustomer";
import Household from "@/pages/offer-details-questionnaire/parts/Household";
import LoadingSpinner from "@/components/LoadingSpinner";
import { isEmpty } from "lodash";
import ApplyApplication from "@/pages/Bewerbung/ApplyApplication";

export default {
  name: "OfferDetails",
  components: {
    ApplyApplication,
    LoadingSpinner,
    IndicationOfCareSituation,
    HealthConditionDetails,
    ScopeOfServices,
    Support,
    HouseholdSituations,
    InfoAboutCustomer,
    Household,
  },
  data() {
    return {
      patientIdx: 1,
      loading: true,
      showApplyForm: false,
      isModalVisible: false,
      showModal: false,
    };
  },
  computed: {
    details() {
      return this.$store.getters["offer/details"];
    },
  },
  created() {
    this.$store.dispatch("offer/details", this.$route.params.id).then(() => {
      this.loading = false;
    });
  },
  destroyed() {
    this.$store.commit("offer/setDetails", {});
  },
  methods: {
    formatPrice(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    isEmpty(val) {
      return isEmpty(val);
    },
    selectedOffers(id, val) {
      this.$store.dispatch("offer/toggleFav", {
        offerId: id,
        page: "list",
      });
      val.favorite = !val.favorite;
      
    },
  },
};
</script>

<style>
.tab-content {
  max-height: 0;
  -webkit-transition: max-height 0.35s;
  -o-transition: max-height 0.35s;
  transition: max-height 0.35s;
}

.tab input:checked ~ .tab-content {
  max-height: unset;
}
.tab input:checked + label {
  display: flex;
  background: #63b15b;
}
.tab input:checked + label span.flex.transform.rotate-0 {
  transform: rotate(0deg) !important;
}
.tab label::after {
  float: right;
  right: 0;
  top: 0;
  width: 1.5em;
  height: 1.5em;
  line-height: 1.5;
  font-size: 1.25rem;
  text-align: center;
  -webkit-transition: all 0.35s;
  -o-transition: all 0.35s;
  transition: all 0.35s;
  display: none;
}
.tab input[type="checkbox"] + label::after {
  content: "+";
  font-weight: bold;
  border-width: 1px;
  border-radius: 9999px;
  border-color: #b8c2cc;
}
.tab input[type="radio"] + label::after {
  content: "\25BE";
  font-weight: bold;
  border-width: 1px;
  border-radius: 9999px;
  border-color: #b8c2cc;
  display: none;
}

.tab input[type="checkbox"]:checked + label::after {
  transform: rotate(315deg);
  background-color: #6574cd;
  color: #f8fafc;
}
.tab input[type="radio"]:checked + label::after {
  transform: rotateX(180deg);
  background-color: #6574cd;
  color: #f8fafc;
}
.tab input[type="radio"]:checked + label .iconbox {
  transform: rotate(180deg);
}
.tab input:checked + label span {
  color: white;
}

.tab input:checked + label {
  
  box-shadow: 0px 2px 6px 1px rgb(0 0 0 / 13%);
  padding-left: 1rem;
  padding-right: 1rem;
}

.accordian-block .tab .iconbox svg path {
  fill: #63b15b;
}

.tab input:checked + label .iconbox svg path {
  fill: white;
}
.tab input:checked + label .rotate-0 {
  -webkit-transform: rotate(0deg) !important;
  transform: rotate(0deg) !important;
}

.bg-green {
  background: #63b15b;
}
.modal-vue .overlay {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-vue .modal {
  position: relative;
  width: 300px;
  z-index: 9999;
  margin: 0 auto;
  padding: 20px 30px;
  background-color: #fff;
}

.modal-vue .close {
  position: absolute;
  top: 10px;
  right: 10px;
}
.tooltip {
  position: absolute;
    top: -18px;
    margin-left: 17px;
    max-width: 236px;
white-space: nowrap;
  opacity: 0;
  padding: 10px;
  height: 37px;
  color: white;
  text-align: center;
  background: #63b15b;
  border-radius: 5px;

}

.wrapper:hover > .tooltip {
  opacity: 1;
}
</style>
